import React from "react";
import Header from "@/components/Header/Header";
import RiskWeather from "@/components/RiskWeather/RiskWeather";
import { FetchRiskData } from "@/pages/api/FetchRiskData";

function RiskWeatherScreen(props) {
    return (
        <>
            <Header content="Adaptive Risk Weather"
                page_head="Risk Weather Tool"
                description="Chart the risk contribution of individual holdings in a portfolio, for better understanding of portfolio risk including the benefits of diversification even among volatile holdings"
                keywords="Adaptive, AdaptiveInvestmentSolutions, Adaptive Investment Solutions, Downside Protection, DownsideProtection, VIX, Implied Volatility, ImpliedVolatility, Market Risk, MarketRisk, Volatility Tax, VolatilityTax"
            />
            <RiskWeather {...props} />
        </>
    )
}

export async function getServerSideProps() {
    const data = await FetchRiskData();
    return {
        props: {
            data,
        },
    };
}

export default RiskWeatherScreen;